import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/book';
const backUrl='/library'+Url;
const adddeleteUrl='/library/book-add-delete/';
const menuUrl='/getallbookcategory';

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            isbn_no:'',
            title:'',
            book_category_id:'',
            ddci_number:'',
            author_name:'',
            publish_year:'',
            quantity:'',
            purchase_date:'',
            entry_date:'',
            edition:'',
            price:'',
            pages:'',
            publisher:'',
            no_of_due_days_student:'',
            no_of_due_days_staff :'',
            rack_no: '',
            status:1,
            bookCategoryData:[],
            preloader:this.props.match.params.id?true:false,
            pagetitle:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){

        viewData(menuUrl).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({bookCategoryData:datam});
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            this.setState({
                                isbn_no:data.isbn_no?data.isbn_no:'',
                                title:data.title?data.title:'',
                                book_category_id:data.book_category_id?data.book_category_id:'',
                                rack_no:data.rack_no?data.rack_no:'',
                                ddci_number:data.ddci_number?data.ddci_number:'',
                                author_name:data.author_name?data.author_name:'',
                                publish_year:data.publish_year?data.publish_year:'',
                                quantity:data.quantity?data.quantity:'',
                                purchase_date:data.purchase_date?moment(new Date(data.purchase_date)):'',
                                entry_date:data.entry_date?moment(new Date(data.entry_date)):'',
                                edition:data.edition?data.edition:'',
                                price:data.price?data.price:'',
                                pages:data.pages?data.pages:'',
                                publisher:data.publisher?data.publisher:'',
                                no_of_due_days_student:data.no_of_due_days_student?data.no_of_due_days_student:'',
                                no_of_due_days_staff:data.no_of_due_days_staff?data.no_of_due_days_staff:'',
                                status:data.status,
                                preloader:false, 
                            });
                        }
                    });
                }
            }
        });
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] =event.target.name==='status'?event.target.value==0?1:0:event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            const {isbn_no,title,book_category_id,rack_no,ddci_number,author_name,publish_year,quantity,purchase_date,entry_date,edition,price,pages,publisher,no_of_due_days_student,no_of_due_days_staff,status} = this.state;
            let params={
                isbn_no,title,book_category_id,rack_no,ddci_number,author_name,publish_year,quantity,purchase_date:moment(purchase_date),entry_date:moment(entry_date),edition,price,pages,publisher,no_of_due_days_student,no_of_due_days_staff,status
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handlePurchaseDate=(date)=>{
        this.setState({purchase_date: date});
    }

    handleEntryDate=(date)=>{
        this.setState({entry_date: date});
    }
  
    render() {
        const {pagetitle,preloader,isbn_no,title,book_category_id,rack_no,ddci_number,author_name,publish_year,quantity,purchase_date,entry_date,edition,price,pages,publisher,no_of_due_days_student,no_of_due_days_staff,bookCategoryData,status} = this.state;

        const role=permissionCheck('book',pagetitle);
        if(!role)
            return <Nopermission/>;
        const titleValid = this.validator.message('title',title, 'required');
        const isbn_noValid = this.validator.message('isbn_no',isbn_no, 'required');
        const book_category_idValid = this.validator.message('book_category_id',book_category_id, 'required');
        const rack_noValid = this.validator.message('rack_no',rack_no, 'required');
        const ddci_numberValid = this.validator.message('ddci_number',ddci_number, 'required');
        const author_nameValid = this.validator.message('author_name',author_name, 'required');
        //const publish_yearValid = this.validator.message('publish_year',publish_year, 'required');
        const quantityValid = this.validator.message('quantity',quantity, 'required');
        const purchase_dateValid = this.validator.message('purchase_date',purchase_date, 'required');
        const entry_dateValid = this.validator.message('entry_date',entry_date, 'required');
        const editionValid = this.validator.message('edition',edition, 'required');
        const priceValid = this.validator.message('price',price, 'required');
        const pagesValid = this.validator.message('pages',pages, 'required');
        const publisherValid = this.validator.message('publisher',publisher, 'required');
        const no_of_due_days_studentValid = this.validator.message('no_of_due_days_student',no_of_due_days_student, 'required');
        const no_of_due_days_staffValid = this.validator.message('no_of_due_days_staff',no_of_due_days_staff, 'required');
        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{pagetitle} Book</h3>
                <div className="md-card">
                    <div className="md-card-content small-padding">
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${title ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Book Title<span className="req">*</span></label>
                                    <input type="text" name="title" value={title} onChange={this.setStateFromInput} className={ `md-input ${titleValid ?'md-input-danger':''}`} /> 
                                    {titleValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${edition ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Edition<span className="req">*</span></label>
                                    <input type="text" name="edition" value={edition} onChange={this.setStateFromInput} className={ `md-input ${editionValid ?'md-input-danger':''}`} /> 
                                    {editionValid} 
                                </div>
                            </div>                       
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${author_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Author Name<span className="req">*</span></label>
                                    <input type="text" name="author_name" value={author_name} onChange={this.setStateFromInput} className={ `md-input ${author_nameValid ?'md-input-danger':''}`} /> 
                                    {author_nameValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${isbn_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">ISBN No<span className="req">*</span></label>
                                    <input type="text" name="isbn_no" value={isbn_no} onChange={this.setStateFromInput} className={ `md-input ${isbn_noValid ?'md-input-danger':''}`} /> 
                                    {isbn_noValid} 
                                </div>
                            </div>
                            
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${ddci_number ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">DDCI Number<span className="req">*</span></label>
                                    <input type="text" name="ddci_number" value={ddci_number} onChange={this.setStateFromInput} className={ `md-input ${ddci_numberValid ?'md-input-danger':''}`} /> 
                                    {ddci_numberValid} 
                                </div>
                            </div>
                        </div>   
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${publish_year ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Publish Year</label>
                                    <input type="text" name="publish_year" value={publish_year} onChange={this.setStateFromInput} className={ 'md-input'} />  
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${pagetitle==='Edit' ? 'md-input-wrapper-disabled' : ''} ${quantity ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Quantity<span className="req">*</span></label>
                                    { pagetitle==='New'?
                                        <input type="text" name="quantity" value={quantity} onChange={this.setStateFromInput} className={ `md-input ${quantityValid ?'md-input-danger':''}`} />:
                                        <input type="text" name="quantity" value={quantity}  className="md-input" disabled/>
                                    } 

                                    {quantityValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${price ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Price<span className="req">*</span></label>
                                    <input type="text" name="price" value={price} onChange={this.setStateFromInput} className={ `md-input ${priceValid ?'md-input-danger':''}`} /> 
                                    {priceValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${publisher ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Publisher<span className="req">*</span></label>
                                    <input type="text" name="publisher" value={publisher} onChange={this.setStateFromInput} className={ `md-input ${publisherValid ?'md-input-danger':''}`} /> 
                                    {publisherValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${no_of_due_days_student ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">No of due days for student<span className="req">*</span></label>
                                    <input type="text" name="no_of_due_days_student" value={no_of_due_days_student} onChange={this.setStateFromInput} className={ `md-input ${no_of_due_days_studentValid ?'md-input-danger':''}`} /> 
                                    {no_of_due_days_studentValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${no_of_due_days_staff ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">No of due days staff<span className="req">*</span></label>
                                    <input type="text" name="no_of_due_days_staff" value={no_of_due_days_staff} onChange={this.setStateFromInput} className={ `md-input ${no_of_due_days_staffValid ?'md-input-danger':''}`} /> 
                                    {no_of_due_days_staffValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${publisher ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="book_category_id" onChange={this.setStateFromInput} value={book_category_id}>
                                        <option value="">Select Book Category</option>
                                        {
                                            bookCategoryData && bookCategoryData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.book_category_id} >{val.name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {book_category_idValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${purchase_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Purchase Date<span className="req">*</span></label>
                                    <DatePicker name="testing" selected={purchase_date} dateFormat="DD/MM/YYYY" className="datepicker md-input" onChange={this.handlePurchaseDate} />
                                    {purchase_dateValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${entry_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Entry Date<span className="req">*</span></label>
                                    <DatePicker selected={entry_date} dateFormat="DD/MM/YYYY" className="datepicker md-input" onChange={this.handleEntryDate} />
                                    {entry_dateValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${pages ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Pages<span className="req">*</span></label>
                                    <input type="text" name="pages" value={pages} onChange={this.setStateFromInput} className={ `md-input ${pagesValid ?'md-input-danger':''}`} /> 
                                    {pagesValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${rack_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Rack Number</label>
                                    <input type="text" name="rack_no" value={rack_no} onChange={this.setStateFromInput} className={ 'md-input'} />  
                                    {rack_noValid}
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={status==1?1:0} onChange={this.setStateFromInput} type="radio" name="status" id="radio_demo_1" value="0" />
                                        <label htmlFor="radio_demo_1" className="inline-label">Active</label>
                                        <input type="radio" name="status" id="radio_demo_2" checked={status==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="radio_demo_2" className="inline-label">Inactive</label>
                                    </span>
                                </div>
                            </div> 
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                {
                                    pagetitle==='Edit' &&
                                <Link to={adddeleteUrl+this.props.match.params.id} className="md-btn md-btn-small md-btn-success md-btn-wave-light waves-effect waves-button waves-light">add / delete individual book</Link>
                                }
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Library/Book/addEdit.js